import { render, staticRenderFns } from "./QueueSelect.vue?vue&type=template&id=2e32a3ce"
import script from "./QueueSelect.vue?vue&type=script&lang=js"
export * from "./QueueSelect.vue?vue&type=script&lang=js"
import style0 from "./QueueSelect.vue?vue&type=style&index=0&id=2e32a3ce&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QSpinner,QField});
